// extracted by mini-css-extract-plugin
export default {"root":"Players_root__ei8D1","legend":"Players_legend__4YdLr","card":"Players_card__kyY-T","playerAddress":"Players_playerAddress__j3BfN"};